module.exports = __webpack_public_path__ + "img/1576762971.5e9d3ad7.jpg";